export enum CustomizeTab {
  COLORZONES = 'colorzones',
  GRAPHICS = 'graphics',
  NAME_NUMBER = 'name-number'
};